'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../aviary-core/dist/cjs/index.cjs');
var React = require('react');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@remix-run/react');
require('react-router-dom');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../aviary-tokens/dist/cjs/index.cjs');
require('aviary-tokens');
var InternalTextInput_web = require('../../internal/InternalTextInput/InternalTextInput.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');

/**
 * EmailInput component is used to display an html input type="email".
 * Includes basic validation (required, includes "@", includes ".", is regex valid) onBlur.
 *
 * {@link https://aviary.fullscript.io/latest/components/email-input/web-RqOXxUzz | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/EmailInput/EmailInput.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const EmailInput = ({ label = "Email", errorCaption, value, required = false, onBlur, ...rest })=>{
    const [isDirty, setIsDirty] = React.useState(false);
    const handleBlur = (e)=>{
        setIsDirty(true);
        if (onBlur) {
            onBlur(e);
        }
    };
    const { validationError } = index.useEmailValidation({
        isDirty,
        required,
        value: String(value),
        label
    });
    return /*#__PURE__*/ jsxRuntime.jsx(InternalTextInput_web.InternalTextInput, {
        "data-testid": "aviary-email-input",
        type: "email",
        value: value,
        required: required,
        label: label,
        errorCaption: [
            errorCaption,
            validationError
        ],
        inputMode: "email",
        onBlur: handleBlur,
        ...rest
    });
};

exports.EmailInput = EmailInput;
//# sourceMappingURL=EmailInput.web.cjs.map
